"use strict";var g=Object.defineProperty;var h=Object.getOwnPropertyDescriptor;var e=(n,l,a,s)=>{for(var i=s>1?void 0:s?h(l,a):l,o=n.length-1,u;o>=0;o--)(u=n[o])&&(i=(s?u(l,a,i):u(i))||i);return s&&i&&g(l,a,i),i};import{baseStyles as d,CiscoUElement as y,colors as c,html as p,nothing as r}from"@cisco-u/base";import{property as t}from"@cisco-u/base/src/decorators.js";import b from"./button.css.js";export class Button extends y{constructor(){super(...arguments);this.disabled=!1}static get styles(){return[d,c,b]}render(){return this.display?this._returnDisplay():this.href?this._returnLink():this._returnButton()}_returnButton(){return p`
      <button
        aria-label=${this.label}
        title=${this.label}
        @click=${this._dispatchButtonClick}
        disabled=${this.disabled||r}
        active=${this.active||r}
      >
        <slot></slot>
      </button>
    `}_returnLink(){return p`
      <a
        aria-label=${this.label}
        title=${this.label}
        href=${this._returnHref()}
        @click=${this._dispatchButtonClick}
        target=${this._returnTarget()}
        rel=${this._returnRel()}
        disabled=${this.disabled||r}
        size=${this.size||r}
        active=${this.active||r}
      >
        <slot></slot>
      </a>
    `}_returnDisplay(){return p`
      <span disabled=${this.disabled||r}>
        <slot></slot>
      </span>
    `}_returnTarget(){return this.target||r}_returnHref(){return this.href||"#"}_returnRel(){return this.rel||r}_dispatchButtonClick(a){this.dispatchEvent(new CustomEvent("cu-button",{detail:{event:a}}))}}e([t({type:String,reflect:!0})],Button.prototype,"template",2),e([t({type:Boolean,reflect:!0})],Button.prototype,"disabled",2),e([t({type:String,reflect:!0})],Button.prototype,"href",2),e([t({type:String,reflect:!0})],Button.prototype,"size",2),e([t({type:String,reflect:!0})],Button.prototype,"target",2),e([t({type:String,reflect:!0})],Button.prototype,"rel",2),e([t({type:Boolean,reflect:!0})],Button.prototype,"ghost",2),e([t({type:Boolean,reflect:!0})],Button.prototype,"display",2),e([t({type:String,reflect:!0})],Button.prototype,"label",2),e([t({type:Boolean,reflect:!0})],Button.prototype,"circle",2),e([t({type:Boolean,reflect:!0})],Button.prototype,"active",2);
//# sourceMappingURL=Button.js.map
